import Translation from '../../Translation/cont/Translation'
import RadioButtonGroup from './RadioButtonGroup'
import ItemPerfomancesCheckbox from './ItemPerformancesCheckbox'

const ItemPerfomancesCheckboxGroup = ({
    transIdDescription,
    buttonsConfig,
    dataKey,
    itemData,
    flyerPk = null,
    onUpdate
}) => {
    const onSetItem = value => {
        let data 
        if(flyerPk) {
            data = {
                [dataKey]: value,
                flyerPk: flyerPk
            }
        } else {
            data = {
                [dataKey]: value
            }
        }

        onUpdate({
            ... itemData,
            ... data
        })
    }

    let currentData = itemData[dataKey]

    if(!itemData[dataKey]) {
        currentData = []
    }

    return (
        <RadioButtonGroup
            description={<Translation id={transIdDescription}/>}
            className={'field-checkbox input-' + dataKey}
        >
            {buttonsConfig.map(button => {
                const buttonId = itemData.id + button.value
                const name = button.transId ? <Translation id={button.transId}/> : button.name
                
                return (
                    <ItemPerfomancesCheckbox
                        key={buttonId}
                        id={buttonId}
                        name={itemData.id + dataKey}
                        value={button.value}
                        currentValue={currentData}
                        label={name}
                        onChange={onSetItem}
                    />
                )
            })}
        </RadioButtonGroup>
    )
}
export default ItemPerfomancesCheckboxGroup